import request from '../../config/request.js'

export const apiService = {
    /**
     * 查询首页导航栏菜单
     */
    findHomeMenu () {
        
        return request.get('/api/findHomeMenu')

    },
    /**
     * 查询所有菜单
     */
    findAllMenu () {
        return request.get('/api/findAllMenu')
    },
    /**
     * 查询首页轮播图
     */
    findHomeCarousel(params) {
        return request.get('/api/findHomeCarousel', {params})
    },

    /**
     * 查询首页文章
     * @param {*} params 
     * @returns 
     */
    findHomePageArticle(params) {
        return request.get('/api/findHomePageArticle', {params})
    },

    /**
     * 查询文章
     * @param {*} params 
     * @returns 
     */
    findArticle(params) {
        return request.get('/api/findArticle', {params})
    },
    /**
     * 查询首页文章
     * @param {*} params 
     * @returns 
     */
     findArticleById(articleId) {
        return request.get('/api/findArticleById', {params: {articleId}})
    },
    /**
     * 查询外部文章
     * @param {*} params 
     * @returns 
     */
    findArticleByPath(path) {
        return request.get('/api/findArticleByPath', {params: {path}})
    },
    /**
     * 查询学校概括
     * @returns 
     */
     findSchoolSummarizeByType (ssType) {
        return request.get('/api/findSchoolSummarizeByType', {params: {ssType}})
     },
    /**
     * 查询首页视频
     */
     findSchoolVideo(params) {
        return request.get('/api/findSchoolVideo', {params})
     },

     /**
      * 查询校园风采图
      */
      findCampusStyleImg(params) {
        return request.get('/api/findCampusStyleImg', {params})
      },
      /**
       * 增加文章浏览次数
       */
       addViewTimes(articleId) {

        request.get('/api/article/addViewTimes', {params: {articleId}})
    },
       /**
        * 首页广告
        */
        findShowAd() {
            return request.get('/api/ad/findShowAd')
        },
    /**
     * 查询专题网站
     */
     findFeaturedList() {
         return request.get('/api/featured/findFeaturedList')
     }
}
export const RESULT_CODE = {
    SUCCESS: 0
}


// WEBPACK FOOTER //
// ./src/api/ApiService.js